module.exports = __webpack_public_path__ + "static/media/logout.7246266a.svg";